import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#080503] py-12 border-t border-white/5 text-center" data-id="element-45">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-46">
        <div className="text-2xl font-bold text-white tracking-tight mb-8" data-id="element-47">
          Postres en <span className="text-[#d4a843]" data-id="element-48">Vaso</span>
        </div>

        <div className="flex justify-center gap-6 opacity-50 mb-8" data-id="element-49">
          <div className="px-3 py-1 bg-white rounded text-[#0d0906] font-bold text-xs flex items-center" data-id="element-50">
            VISA
          </div>
          <div className="px-3 py-1 bg-white rounded text-[#0d0906] font-bold text-xs flex items-center" data-id="element-51">
            MASTERCARD
          </div>
          <div className="px-3 py-1 bg-[#009EE3] rounded text-white font-bold text-xs flex items-center" data-id="element-52">
            mercado pago
          </div>
        </div>

        <p className="text-[#c9b99a]/50 text-sm mb-4" data-id="element-53">
          © {currentYear} Postres en Vaso. Todos los derechos reservados.
        </p>

        <p className="text-[#c9b99a]/30 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-54">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc. Los resultados
          pueden variar de persona a persona.
        </p>
      </div>
    </footer>;
}